import React from 'react';
import { MdClose } from 'react-icons/md';
import {
  SPEECH_BUBBLE_SIZE_MEDIUM,
  SPEECH_BUBBLE_TAIL_START,
  type SpeechBubbleSize,
  type SpeechBubbleTail,
} from './SpeechBubble.constants';
import { CloseButton, Dot, Dots, Root } from './SpeechBubble.styled';

interface SpeechBubbleBaseProps {
  children?: React.ReactNode;
  tail?: SpeechBubbleTail;
  size?: SpeechBubbleSize;
  /** Shows three bouncing dots in place of the text, as if the speaker were typing. */
  typing?: boolean;
  typingLabel?: string;
  className?: string;
  dataTestId?: string;
}

export type SpeechBubbleProps = SpeechBubbleBaseProps &
  ({ onClose?: undefined; closeLabel?: undefined } | { onClose: () => void; closeLabel: string });

const SpeechBubble: React.FC<SpeechBubbleProps> = ({
  children,
  tail = SPEECH_BUBBLE_TAIL_START,
  size = SPEECH_BUBBLE_SIZE_MEDIUM,
  typing = false,
  typingLabel = 'Typing',
  onClose,
  closeLabel,
  className,
  dataTestId = 'speech-bubble',
}) => (
  <Root
    $tail={tail}
    $size={size}
    $closable={Boolean(onClose)}
    data-tail={tail}
    data-typing={typing || undefined}
    className={className}
    data-testid={dataTestId}
  >
    {typing ? (
      <Dots aria-label={typingLabel} role="status">
        <Dot />
        <Dot />
        <Dot />
      </Dots>
    ) : (
      children
    )}
    {onClose && (
      <CloseButton type="button" aria-label={closeLabel} onClick={onClose} data-testid={`${dataTestId}__close`}>
        <MdClose size={14} aria-hidden="true" />
      </CloseButton>
    )}
  </Root>
);

export default SpeechBubble;
